import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// First-party pageview beacon for the visitor_events table (see
// server/tracking.js) — independent of whatever third-party analytics script
// is also on the page.
export default function usePageTracking() {
  const location = useLocation()
  const previousPath = useRef(null)
  const lastSent = useRef(null)

  useEffect(() => {
    const path = location.pathname + location.search
    // Skip a repeat beacon for the same path — StrictMode runs this effect
    // twice on mount in dev, which would otherwise double-count the pageview
    // (and record the current path as its own referrer). Real navigations
    // always change the path, so this never suppresses a genuine pageview.
    if (lastSent.current === path) return
    lastSent.current = path

    fetch('/api/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, referrer: previousPath.current || document.referrer || null }),
      keepalive: true,
    }).catch(() => {})
    previousPath.current = path
  }, [location.pathname, location.search])
}
